export default "__VITE_ASSET__27219a22__"